function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { literalValueTypes } from "../../primitives";
import { idValidator } from "../misc/id-validator";
export const stateValueValidator = T.model("state", T.object({
    typeName: T.literal("state_value"),
    id: idValidator("state_value"),
    // path: T.string,
    value: literalValueTypes
}));
export const SWStateValueRecordType = createRecordType("state_value", {
    migrations: defineMigrations({}),
    validator: stateValueValidator,
    scope: "session"
});
export function isStateValue(record) {
    if (!record) return false;
    return record.typeName === "state_value";
}
export function isStateValueId(id) {
    if (!id) return false;
    return id.startsWith("state_value:");
}
/** @public */ export function createStateValueId(id) {
    return `state_value:${id !== null && id !== void 0 ? id : nanoid()}`;
}
export function createStateValue(stateValue) {
    return _object_spread_props(_object_spread({}, stateValue), {
        id: createStateValueId(stateValue.id)
    });
}
